import { isPathLookupEdgeData } from '@ipfabric/utils';
import type { PacketDetailMouseEvent } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetail';
import {
  EDGE_HIGHLIGHT_THICKNESS,
  FOLLOWING_EDGE_HIGHLIGHT_COLOR,
} from 'components/Graph/constants';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { highlightEdges } from '../pathLookup/highlightEdges';
import { getIncomingEdgeIds } from './helpers/getIncomingEdgeIds';

export const pathLookupDetailPreviousButtonMouseEnter: GraphCommandFactory<
  PacketDetailMouseEvent
> = (cmdContext, dispatch) => (command) => {
  const foundEdge = cmdContext.getState().graph.edges[command.detailId];
  if (foundEdge === undefined || !isPathLookupEdgeData(foundEdge)) {
    return;
  }

  const foundNode = cmdContext.getState().graph.nodes[foundEdge.source];
  if (foundNode === undefined) {
    return;
  }

  const incomingEdgeIds = getIncomingEdgeIds(
    cmdContext.getState(),
    command.detailId,
    foundNode.id,
  );

  if (incomingEdgeIds === undefined || incomingEdgeIds.length === 0) {
    return;
  }

  // Highlight edges from following node
  dispatch(highlightEdges, {
    edges: incomingEdgeIds,
    color: FOLLOWING_EDGE_HIGHLIGHT_COLOR,
    thickness: EDGE_HIGHLIGHT_THICKNESS,
  });
};
